import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "segment-search",
  ref: "searchContainer"
}
const _hoisted_2 = { class: "results-container" }
const _hoisted_3 = {
  key: 0,
  class: "load-more"
}
const _hoisted_4 = {
  key: 1,
  class: "no-results"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchResultItem = _resolveComponent("SearchResultItem")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_popover, {
      visible: _ctx.showPopover,
      placement: "bottom-start",
      "show-arrow": false,
      width: _ctx.popoverWidth,
      "popper-class": "search-results-popover",
      teleported: true
    }, {
      reference: _withCtx(() => [
        _createVNode(_component_el_input, {
          id: "search-input",
          modelValue: _ctx.searchText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          placeholder: _ctx.$t('segmentSearch.search'),
          class: "search-input",
          clearable: "",
          onInput: _ctx.onSearchInput,
          onFocus: _ctx.onFocus,
          onClear: _ctx.onClear
        }, {
          prefix: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "material-symbols-outlined search-icon" }, "search", -1)
          ]))]),
          _: 1
        }, 8, ["modelValue", "placeholder", "onInput", "onFocus", "onClear"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.results.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
                        return (_openBlock(), _createBlock(_component_SearchResultItem, {
                          key: result.translationSegmentId,
                          result: result,
                          searchText: _ctx.searchText,
                          searchField: _ctx.searchField,
                          onSelect: _ctx.handleResultSelect
                        }, null, 8, ["result", "searchText", "searchField", "onSelect"]))
                      }), 128)),
                      (_ctx.hasMore)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_component_el_button, {
                              onClick: _ctx.loadMore,
                              loading: _ctx.loadingMore,
                              type: "primary",
                              link: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('segmentSearch.loadMore')) + " (" + _toDisplayString(_ctx.remainingCount) + ") ", 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "loading"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('segmentSearch.noResults')), 1))
              ], 64))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["visible", "width"])
  ], 512))
}